// import React, { useState } from "react";
// import { Link, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux";

// const Account = () => {
//   const user = useSelector((state) => state.user.user);
//   const [open, setOpen] = useState(false);

//   return (
//     <div className="min-h-screen bg-gray-100 py-4 md:py-8">

//       <div className="max-w-7xl mx-auto px-3 md:px-4">

//         {/* 🔥 MOBILE HEADER */}
//         <div className="md:hidden flex justify-between items-center mb-4">
//           <h2 className="font-semibold text-lg">My Account</h2>

//           <button
//             onClick={() => setOpen(!open)}
//             className="bg-black text-white px-3 py-1 rounded"
//           >
//             Menu
//           </button>
//         </div>

//         <div className="flex flex-col md:flex-row gap-4 md:gap-6">

//           {/* 🔥 SIDEBAR */}
//           <div
//             className={`
//               ${open ? "block" : "hidden"} 
//               md:block
//               w-full md:w-64 
//               bg-white rounded shadow p-4
//             `}
//           >

//             <div className="mb-6 border-b pb-3">
//               <h2 className="font-semibold text-base md:text-lg">
//                 {user?.name}
//               </h2>
//               <p className="text-xs md:text-sm text-gray-500">
//                 {user?.email}
//               </p>
//             </div>

//             <nav className="flex flex-col gap-3 text-sm">

//               <Link to="profile" className="hover:text-red-600">
//                 My Profile
//               </Link>

//               <Link to="orders" className="hover:text-red-600">
//                 My Orders
//               </Link>

//               <Link to="address" className="hover:text-red-600">
//                 Address
//               </Link>

//               <Link to="wallet" className="hover:text-red-600">
//                 Wallet
//               </Link>

//               <Link to="help" className="hover:text-red-600">
//                 Help Center
//               </Link>

//               {user?.role === "ADMIN" && (
//                 <Link
//                   to="/dashboard"
//                   className="text-blue-600 font-medium"
//                 >
//                   Admin Panel
//                 </Link>
//               )}

//             </nav>
//           </div>

//           {/* 🔥 CONTENT */}
//           <div className="flex-1 bg-white rounded shadow p-4 md:p-6">
//             <Outlet />
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// };

// export default Account;
import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUser,
  FaBox,
  FaMapMarkerAlt,
  FaWallet,
  FaHeadset,
  FaBars,
  FaTimes,
} from "react-icons/fa";

const Account = () => {
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const menu = [
    { name: "My Profile", path: "profile", icon: <FaUser /> },
    { name: "My Orders", path: "orders", icon: <FaBox /> },
    { name: "Address", path: "address", icon: <FaMapMarkerAlt /> },
    { name: "Wallet", path: "wallet", icon: <FaWallet /> },
    { name: "Help Center", path: "help", icon: <FaHeadset /> },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">

      {/* 🔥 MOBILE HEADER */}
      <div className="md:hidden flex justify-between items-center p-4 bg-white shadow">
        <h2 className="font-semibold text-lg">My Account</h2>

        <button
          onClick={() => setOpen(true)}
          className="text-xl"
        >
          <FaBars />
        </button>
      </div>

      <div className="max-w-7xl mx-auto flex gap-6 p-4">

        {/* 🔥 SIDEBAR DESKTOP */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="hidden md:block w-64 bg-white rounded-2xl shadow-lg p-5"
        >
          {/* Profile */}
          <div className="text-center mb-6">
            <div className="w-16 h-16 mx-auto bg-gradient-to-r from-green-500 to-green-600 text-white flex items-center justify-center rounded-full text-xl font-bold shadow">
              {user?.name?.charAt(0) || "U"}
            </div>
            <h3 className="mt-3 font-semibold">{user?.name}</h3>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>

          {/* Menu */}
          <div className="space-y-2">
            {menu.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center gap-3 p-3 rounded-lg transition-all ${
                  location.pathname.includes(item.path)
                    ? "bg-green-500 text-white shadow"
                    : "hover:bg-gray-100"
                }`}
              >
                {item.icon} {item.name}
              </Link>
            ))}

            {user?.role === "ADMIN" && (
              <Link
                to="/dashboard"
                className="block mt-3 text-blue-600 font-medium"
              >
                Admin Panel
              </Link>
            )}
          </div>
        </motion.div>

        {/* 🔥 MOBILE SIDEBAR */}
        <AnimatePresence>
          {open && (
            <>
              {/* Overlay */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.4 }}
                exit={{ opacity: 0 }}
                onClick={() => setOpen(false)}
                className="fixed inset-0 bg-black z-40"
              />

              {/* Sidebar */}
              <motion.div
                initial={{ x: -300 }}
                animate={{ x: 0 }}
                exit={{ x: -300 }}
                className="fixed top-0 left-0 w-64 h-full bg-white z-50 shadow-lg p-5"
              >
                <div className="flex justify-between items-center mb-5">
                  <h3 className="font-semibold">Menu</h3>
                  <FaTimes onClick={() => setOpen(false)} className="cursor-pointer" />
                </div>

                {/* Profile */}
                <div className="mb-6">
                  <h3 className="font-semibold">{user?.name}</h3>
                  <p className="text-sm text-gray-500">{user?.email}</p>
                </div>

                {/* Menu */}
                <div className="space-y-3">
                  {menu.map((item) => (
                    <Link
                      key={item.name}
                      to={item.path}
                      onClick={() => setOpen(false)}
                      className="block hover:text-green-600"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>

        {/* 🔥 CONTENT */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex-1 bg-white rounded-2xl shadow-lg p-4 md:p-6"
        >
          <Outlet />
        </motion.div>

      </div>
    </div>
  );
};

export default Account;